module.exports = __webpack_public_path__ + "static/maintenance-202ab7b70cb349c91331e7b31aa1701c.jpg";